// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Portal_Reports_GetResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /customer-portal/v1/reports/get
 *
 * Document-keyed read of a single laudo (entry or exit). Re-serves the SAME
 * safe projection as Laudo_publico::getPublic() (the public token-based
 * laudo view), keyed by (document, order_item_id, type) instead of a
 * public token — see that controller for the reference field discipline.
 *
 * Field names are English per ADR-0014 §3 — everything inside the envelope
 * is English; only the three envelope keys {success, dados, error} stay as
 * they are.
 *
 * NEVER exposed here (see customer_portal_reports.php / the portal
 * integration skill): confirmed_by (staff identity), so_reprocessos,
 * work-order/step internals, item alerts/notes, order notes.
 */
import type { Portal_Clientes_FranquiaRow } from './Portal_Clientes_FranquiaRow'
import type { Portal_Reports_AttributeRow } from './Portal_Reports_AttributeRow'
import type { Portal_Reports_ItemAttributeRow } from './Portal_Reports_ItemAttributeRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Portal_Reports_GetResponseDados {
order_item_id: number
order_id: number
type: string
franchise: Portal_Clientes_FranquiaRow
status: string
attributes: Portal_Reports_AttributeRow[]
item_attributes: Portal_Reports_ItemAttributeRow[]
item_description?: string
item_qrcode?: string
confirmed_at?: string
final_status?: string
observations?: string
}

export type Portal_Reports_GetResponse = ApiResponse<Portal_Reports_GetResponseDados>;

registerResponseContract('Portal_Reports_GetResponse', {
  order_item_id:    { type: 'number',  required: true },
  order_id:         { type: 'number',  required: true },
  type:             { type: 'string',  required: true },
  franchise: {
    type: 'object',
    required: true,
    fields: {
      id:    { type: 'string',  required: true },
      name:  { type: 'string',  required: true },
      city:  { type: 'string',  required: false },
      state: { type: 'string',  required: false },
    },
  },
  status:           { type: 'string',  required: true },
  attributes: {
    type: 'array',
    required: true,
    items: {
      attribute_id: { type: 'number',  required: true },
      name:         { type: 'string',  required: true },
      type:         { type: 'string',  required: true },
      value:        { type: 'string',  required: true },
    },
  },
  item_attributes: {
    type: 'array',
    required: true,
    items: {
      attribute_id: { type: 'number',  required: true },
      name:         { type: 'string',  required: true },
      type:         { type: 'string',  required: true },
      value:        { type: 'string',  required: true },
    },
  },
  item_description: { type: 'string',  required: false },
  item_qrcode:      { type: 'string',  required: false },
  confirmed_at:     { type: 'string',  required: false },
  final_status:     { type: 'string',  required: false },
  observations:     { type: 'string',  required: false },
})
